var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAdvanced5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 344,
    viewBox: "0 0 586 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_131_968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 586,
    height: 344
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 586,
    height: 344,
    rx: 15,
    fill: "#F4EFFE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_131_968)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.4141 95.7555C53.6376 73.029 102.199 81.8556 136.514 105.943C147.704 113.904 158.028 123.06 167.195 133.289C172.563 139.146 177.642 145.333 182.515 151.685C183.712 153.252 184.91 154.82 186.066 156.428C186.851 157.501 187.677 158.573 188.461 159.687C198.33 173.38 207.374 187.775 216.21 202.046C238.303 237.642 260.973 274.351 294.627 299.346C301.564 304.501 311.227 309.121 318.33 304.213C324.482 299.923 324.771 290.973 323.367 283.59C318.164 256.326 299.335 233.723 279.348 214.42C259.362 195.117 237.229 177.464 222.157 154.119C207.043 130.815 200.147 99.6739 213.402 75.2975C224.8 54.2621 249.328 42.4657 273.278 41.9295C297.229 41.3933 320.477 50.6737 340.711 63.4599C360.945 76.2462 378.783 92.4146 397.366 107.511C408.556 116.626 424.206 125.659 436.429 117.946C446.753 111.429 447.537 95.7968 441.384 85.279C435.232 74.7613 424.289 68.1207 413.759 61.9751C381.096 42.8369 348.474 23.6576 315.811 4.51943C305.776 -1.33749 295.577 -7.40065 288.144 -16.351C280.752 -25.3014 276.623 -37.8814 280.711 -48.7291C284.717 -59.4531 295.948 -66.2174 307.345 -67.661C318.701 -69.0634 330.139 -65.9287 340.793 -61.6803C380.6 -45.7182 474.337 58.7579 499.319 76.6174C515.383 88.0838 532.23 102.602 533.882 122.277C535.906 146.736 511.542 167.029 487.055 169.421C462.609 171.813 438.907 161.172 417.021 149.953C395.177 138.734 372.878 126.36 348.35 124.793C323.822 123.225 296.32 136.342 290.498 160.182C285.46 180.928 298.302 202.335 315.026 215.616C328.116 226.01 343.519 232.94 358.384 240.735C362.514 242.88 366.602 245.107 370.566 247.499C380.765 253.604 390.304 260.781 399.017 268.865C408.143 277.32 416.361 286.766 423.504 296.995C429.203 305.12 434.158 313.782 438.329 322.773C438.948 324.134 439.568 325.537 440.187 326.939C440.765 328.3 441.302 329.661 441.839 331.064C448.652 349.006 451.295 369.134 442.623 385.88C433.952 402.584 415.122 412.483 396.333 413.844C385.473 414.504 374.571 413.061 364.248 409.596C356.65 407.121 349.3 403.987 342.28 400.151C309.74 382.704 283.973 355.028 260.436 326.609C236.899 298.191 214.765 268.246 186.851 244.076C158.936 219.947 123.919 201.675 87.0028 201.964C50.0863 202.253 12.0136 224.732 1.52503 260.079C-13.9188 233.682 -24.2422 203.696 -22.8795 173.298C-21.5168 142.9 -7.14663 112.254 18.4141 95.7555Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5124 268.66H50.9423C50.3464 268.66 49.8633 269.143 49.8633 269.739V344.108C49.8633 344.704 50.3464 345.187 50.9423 345.187H64.5124C65.1084 345.187 65.5915 344.704 65.5915 344.108V269.739C65.5915 269.143 65.1084 268.66 64.5124 268.66Z",
    fill: "#FACB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5915 274.689H49.8633V277.311H65.5915V274.689Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5915 278.885H49.8633V290.938H65.5915V278.885Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.395 268.66H151.825C151.229 268.66 150.746 269.143 150.746 269.739V344.108C150.746 344.704 151.229 345.187 151.825 345.187H165.395C165.991 345.187 166.474 344.704 166.474 344.108V269.739C166.474 269.143 165.991 268.66 165.395 268.66Z",
    fill: "#FACB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.474 274.69H150.746V277.311H166.474V274.69Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.474 278.885H150.746V290.938H166.474V278.885Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5271 271.021H21.7206C21.1247 271.021 20.6416 271.505 20.6416 272.1V344.115C20.6416 344.711 21.1247 345.194 21.7206 345.194H40.5271C41.1231 345.194 41.6062 344.711 41.6062 344.115V272.1C41.6062 271.505 41.1231 271.021 40.5271 271.021Z",
    fill: "#C90767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3523 328.679H20.9082V331.301H41.3523V328.679Z",
    fill: "#F35E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3523 332.875H20.9082V342.833H41.3523V332.875Z",
    fill: "#ED85B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3523 276.785H20.9082V279.406H41.3523V276.785Z",
    fill: "#ED85B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1346 283.602H26.1125C24.1039 283.602 22.4756 285.23 22.4756 287.238V320.586C22.4756 322.595 24.1039 324.223 26.1125 324.223H36.1346C38.1432 324.223 39.7715 322.595 39.7715 320.586V287.238C39.7715 285.23 38.1432 283.602 36.1346 283.602Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.705 271.022H130.898C130.302 271.022 129.819 271.505 129.819 272.101V344.115C129.819 344.711 130.302 345.194 130.898 345.194H149.705C150.301 345.194 150.784 344.711 150.784 344.115V272.101C150.784 271.505 150.301 271.022 149.705 271.022Z",
    fill: "#C90767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.524 328.679H130.08V331.301H150.524V328.679Z",
    fill: "#F35E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.524 332.875H130.08V342.834H150.524V332.875Z",
    fill: "#ED85B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.524 276.785H130.08V279.407H150.524V276.785Z",
    fill: "#ED85B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.312 283.602H135.29C133.282 283.602 131.653 285.23 131.653 287.239V320.587C131.653 322.595 133.282 324.224 135.29 324.224H145.312C147.321 324.224 148.949 322.595 148.949 320.587V287.239C148.949 285.23 147.321 283.602 145.312 283.602Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9182 251.364H11.5907C10.9948 251.364 10.5117 251.847 10.5117 252.443V344.115C10.5117 344.711 10.9948 345.194 11.5907 345.194H19.9182C20.5141 345.194 20.9972 344.711 20.9972 344.115V252.443C20.9972 251.847 20.5141 251.364 19.9182 251.364Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.737 267.353H10.7783V269.974H20.737V267.353Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.737 271.548H10.7783V274.17H20.737V271.548Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.737 318.72H10.7783V321.342H20.737V318.72Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.737 322.916H10.7783V325.537H20.737V322.916Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.59 251.364H103.263C102.667 251.364 102.184 251.847 102.184 252.443V344.115C102.184 344.711 102.667 345.194 103.263 345.194H111.59C112.186 345.194 112.669 344.711 112.669 344.115V252.443C112.669 251.847 112.186 251.364 111.59 251.364Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.403 267.353H102.444V269.974H112.403V267.353Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.403 271.548H102.444V274.17H112.403V271.548Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.403 318.72H102.444V321.342H112.403V318.72Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.403 322.916H102.444V325.537H112.403V322.916Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52006 270.37L0.244204 269.445C-0.348027 269.378 -0.881807 269.805 -0.948027 270.397L-9.05199 342.874C-9.11821 343.466 -8.69179 344 -8.09956 344.066L0.176295 344.991C0.768525 345.058 1.30231 344.631 1.36853 344.039L9.47248 271.562C9.5387 270.97 9.11229 270.436 8.52006 270.37Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90575 283.177L-1.99121 282.07L-2.22396 284.152L7.673 285.259L7.90575 283.177Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53075 286.51L-2.36621 285.404L-2.59896 287.485L7.298 288.592L7.53075 286.51Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33739 324.028L-6.55957 322.921L-6.79232 325.002L3.10464 326.109L3.33739 324.028Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96239 327.367L-6.93457 326.261L-7.16732 328.342L2.72964 329.449L2.96239 327.367Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2625 257.127H66.456C65.86 257.127 65.377 257.611 65.377 258.206V344.108C65.377 344.704 65.86 345.187 66.456 345.187H85.2625C85.8584 345.187 86.3415 344.704 86.3415 344.108V258.206C86.3415 257.611 85.8584 257.127 85.2625 257.127Z",
    fill: "#F35E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0818 328.679H65.6377V331.3H86.0818V328.679Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0818 332.874H65.6377V335.495H86.0818V332.874Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0818 337.069H65.6377V339.691H86.0818V337.069Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0818 263.684H65.6377V266.305H86.0818V263.684Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0818 267.873H65.6377V270.494H86.0818V267.873Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0818 272.068H65.6377V274.69H86.0818V272.068Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1699 321.862V281.24H74.5486V321.862H77.1699Z",
    stroke: "#F35E9A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6903 259.749H42.4638C41.8679 259.749 41.3848 260.232 41.3848 260.828V344.109C41.3848 344.705 41.8679 345.188 42.4638 345.188H48.6903C49.2862 345.188 49.7693 344.705 49.7693 344.109V260.828C49.7693 260.232 49.2862 259.749 48.6903 259.749Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5114 339.165H49.6357V336.543H41.5114V339.165Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5114 334.969H49.6357V322.916H41.5114V334.969Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5803 272.596C47.0281 272.596 48.2017 271.422 48.2017 269.974C48.2017 268.527 47.0281 267.353 45.5803 267.353C44.1326 267.353 42.959 268.527 42.959 269.974C42.959 271.422 44.1326 272.596 45.5803 272.596Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3739 259.749H87.1474C86.5514 259.749 86.0684 260.232 86.0684 260.828V344.109C86.0684 344.705 86.5514 345.188 87.1474 345.188H93.3739C93.9698 345.188 94.4529 344.705 94.4529 344.109V260.828C94.4529 260.232 93.9698 259.749 93.3739 259.749Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2009 339.165H94.3252V336.543H86.2009V339.165Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2009 334.969H94.3252V322.916H86.2009V334.969Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2571 272.596C91.7048 272.596 92.8785 271.422 92.8785 269.974C92.8785 268.527 91.7048 267.353 90.2571 267.353C88.8094 267.353 87.6357 268.527 87.6357 269.974C87.6357 271.422 88.8094 272.596 90.2571 272.596Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.205 263.195H94.9784C94.3825 263.195 93.8994 263.678 93.8994 264.274V344.108C93.8994 344.704 94.3825 345.187 94.9784 345.187H101.205C101.801 345.187 102.284 344.704 102.284 344.108V264.274C102.284 263.678 101.801 263.195 101.205 263.195Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0261 339.412H102.15V336.898H94.0261V339.412Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0261 335.381H102.15V323.811H94.0261V335.381Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0891 275.522C99.5369 275.522 100.71 274.396 100.71 273.008C100.71 271.62 99.5369 270.495 98.0891 270.495C96.6414 270.495 95.4678 271.62 95.4678 273.008C95.4678 274.396 96.6414 275.522 98.0891 275.522Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.961 260.178L173.169 263.115C172.611 263.325 172.33 263.947 172.54 264.505L202.807 344.816C203.017 345.374 203.639 345.656 204.197 345.446L211.99 342.509C212.547 342.299 212.829 341.676 212.619 341.119L182.351 260.807C182.141 260.249 181.519 259.968 180.961 260.178Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.009 273.921L177.69 277.433L178.557 279.732L187.875 276.22L187.009 273.921Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.397 277.599L179.078 281.111L179.944 283.409L189.263 279.897L188.397 277.599Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.999 318.996L194.68 322.508L195.546 324.806L204.865 321.294L203.999 318.996Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.383 322.67L196.064 326.182L196.931 328.481L206.25 324.969L205.383 322.67Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.256 268.777L167.128 269.881C166.542 269.987 166.152 270.548 166.258 271.134L179.504 344.682C179.61 345.268 180.171 345.658 180.757 345.553L186.885 344.449C187.472 344.343 187.862 343.782 187.756 343.196L174.509 269.648C174.404 269.061 173.843 268.672 173.256 268.777Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.864 340.369L186.859 338.929L186.441 336.605L178.445 338.046L178.864 340.369Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.194 336.656L186.189 335.216L184.267 324.541L176.271 325.981L178.194 336.656Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.243 280.707C173.668 280.451 174.636 279.202 174.404 277.919C174.173 276.635 172.831 275.803 171.406 276.06C169.981 276.316 169.014 277.565 169.245 278.848C169.476 280.132 170.818 280.964 172.243 280.707Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.74 263.417H113.602C113.007 263.417 112.523 263.901 112.523 264.496V344.108C112.523 344.704 113.007 345.187 113.602 345.187H128.74C129.336 345.187 129.819 344.704 129.819 344.108V264.496C129.819 263.901 129.336 263.417 128.74 263.417Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56 269.447H112.784V272.069H129.56V269.447Z",
    fill: "#FACB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.56 337.59H112.784V340.211H129.56V337.59Z",
    fill: "#FACB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.174 287.797C123.201 287.797 124.843 285.45 124.843 282.554C124.843 279.659 123.201 277.312 121.174 277.312C119.148 277.312 117.506 279.659 117.506 282.554C117.506 285.45 119.148 287.797 121.174 287.797Z",
    fill: "#FFEDD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.689 269.702H535.302C534.714 269.702 534.237 270.179 534.237 270.767V344.131C534.237 344.719 534.714 345.196 535.302 345.196H548.689C549.277 345.196 549.753 344.719 549.753 344.131V270.767C549.753 270.179 549.277 269.702 548.689 269.702Z",
    fill: "#FACB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.753 275.65H534.237V278.236H549.753V275.65Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.753 279.789H534.237V291.679H549.753V279.789Z",
    fill: "#FFB522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.027 272.032H506.475C505.887 272.032 505.41 272.508 505.41 273.096V344.138C505.41 344.726 505.887 345.203 506.475 345.203H525.027C525.615 345.203 526.092 344.726 526.092 344.138V273.096C526.092 272.508 525.615 272.032 525.027 272.032Z",
    fill: "#C90767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.841 328.911H505.673V331.497H525.841V328.911Z",
    fill: "#F35E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.841 333.049H505.673V342.873H525.841V333.049Z",
    fill: "#ED85B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.841 277.717H505.673V280.303H525.841V277.717Z",
    fill: "#ED85B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.694 284.442H510.808C508.826 284.442 507.22 286.048 507.22 288.03V320.927C507.22 322.909 508.826 324.515 510.808 324.515H520.694C522.676 324.515 524.282 322.909 524.282 320.927V288.03C524.282 286.048 522.676 284.442 520.694 284.442Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.696 252.64H496.481C495.894 252.64 495.417 253.117 495.417 253.705V344.138C495.417 344.726 495.894 345.203 496.481 345.203H504.696C505.284 345.203 505.761 344.726 505.761 344.138V253.705C505.761 253.117 505.284 252.64 504.696 252.64Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.504 268.413H495.68V270.999H505.504V268.413Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.504 272.551H495.68V275.137H505.504V272.551Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.504 319.086H495.68V321.672H505.504V319.086Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.504 323.225H495.68V325.811H505.504V323.225Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.13 252.64H586.915C586.327 252.64 585.851 253.117 585.851 253.705V344.138C585.851 344.726 586.327 345.203 586.915 345.203H595.13C595.718 345.203 596.194 344.726 596.194 344.138V253.705C596.194 253.117 595.718 252.64 595.13 252.64Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.452 271.389L485.288 270.476C484.704 270.411 484.178 270.832 484.112 271.416L476.118 342.914C476.052 343.498 476.473 344.025 477.057 344.09L485.221 345.003C485.806 345.068 486.332 344.647 486.397 344.063L494.392 272.565C494.457 271.981 494.037 271.454 493.452 271.389Z",
    fill: "#8800FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.846 284.023L483.083 282.931L482.853 284.985L492.617 286.076L492.846 284.023Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.476 287.311L482.713 286.22L482.483 288.273L492.247 289.365L492.476 287.311Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.339 324.322L478.576 323.23L478.347 325.284L488.11 326.376L488.339 324.322Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.969 327.617L478.206 326.525L477.976 328.578L487.74 329.67L487.969 327.617Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.158 258.326H550.605C550.018 258.326 549.541 258.802 549.541 259.39V344.132C549.541 344.72 550.018 345.196 550.605 345.196H569.158C569.746 345.196 570.222 344.72 570.222 344.132V259.39C570.222 258.802 569.746 258.326 569.158 258.326Z",
    fill: "#F35E9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.966 328.911H549.798V331.497H569.966V328.911Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.966 333.049H549.798V335.635H569.966V333.049Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.966 337.188H549.798V339.774H569.966V337.188Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.966 264.793H549.798V267.379H569.966V264.793Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.966 268.926H549.798V271.512H569.966V268.926Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.966 273.065H549.798V275.651H569.966V273.065Z",
    fill: "#E53484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.175 322.186V282.113H558.589V322.186H561.175Z",
    stroke: "#F35E9A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.08 260.912H526.937C526.35 260.912 525.873 261.388 525.873 261.976V344.132C525.873 344.72 526.35 345.196 526.937 345.196H533.08C533.668 345.196 534.144 344.72 534.144 344.132V261.976C534.144 261.388 533.668 260.912 533.08 260.912Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.998 339.254H534.013V336.668H525.998V339.254Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.998 335.115H534.013V323.225H525.998V335.115Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.012 273.585C531.44 273.585 532.598 272.427 532.598 270.999C532.598 269.57 531.44 268.413 530.012 268.413C528.584 268.413 527.426 269.57 527.426 270.999C527.426 272.427 528.584 273.585 530.012 273.585Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.16 260.912H571.018C570.43 260.912 569.953 261.388 569.953 261.976V344.132C569.953 344.72 570.43 345.196 571.018 345.196H577.16C577.748 345.196 578.224 344.72 578.224 344.132V261.976C578.224 261.388 577.748 260.912 577.16 260.912Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.084 339.254H578.099V336.668H570.084V339.254Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.084 335.115H578.099V323.225H570.084V335.115Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.085 273.585C575.513 273.585 576.671 272.427 576.671 270.999C576.671 269.57 575.513 268.413 574.085 268.413C572.657 268.413 571.499 269.57 571.499 270.999C571.499 272.427 572.657 273.585 574.085 273.585Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.886 264.312H578.743C578.155 264.312 577.679 264.788 577.679 265.376V344.132C577.679 344.72 578.155 345.196 578.743 345.196H584.886C585.473 345.196 585.95 344.72 585.95 344.132V265.376C585.95 264.788 585.473 264.312 584.886 264.312Z",
    fill: "#9B8DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.804 339.499H585.818V337.019H577.804V339.499Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.804 335.522H585.818V324.108H577.804V335.522Z",
    fill: "#7665A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.812 276.471C583.24 276.471 584.398 275.361 584.398 273.992C584.398 272.622 583.24 271.512 581.812 271.512C580.383 271.512 579.226 272.622 579.226 273.992C579.226 275.361 580.383 276.471 581.812 276.471Z",
    fill: "#7665A7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAdvanced5);
export default __webpack_public_path__ + "static/media/bg-advanced5.08a87e0a8cfd109f9bdde9e4a89ac00e.svg";
export { ForwardRef as ReactComponent };